export function sumMoney(values) {
  const totalCents = values.reduce((sum, val) => {
    const amount = parseFloat(val);
    if (isNaN(amount)) {
      return 0;
    }

    const cents = Math.round(amount * 100);
    return sum + cents;
  }, 0);

  return (totalCents / 100).toFixed(2);
}

function calculateTotal(rows, cellName) {
  const values = rows.map((row) => row[cellName]).filter((value) => !!value);
  return sumMoney(values);
}

export default function calculateTotals(rows, cols, totalCells) {
  const rowWithTotals = {};
  cols.forEach((col) => {
    if (totalCells.includes(col.key)) {
      rowWithTotals[col.key] = calculateTotal(rows, col.key);
    } else {
      rowWithTotals[col.key] = '';
    }
  });

  return rowWithTotals;
}
